import { render, staticRenderFns } from "./Disabilities.vue?vue&type=template&id=8b08d0ae&scoped=true&"
import script from "./Disabilities.vue?vue&type=script&lang=js&"
export * from "./Disabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b08d0ae",
  null
  
)

export default component.exports